import React, { Fragment, useEffect, useState } from "react";
import { Card, Col, Form, Modal, Row, Select, Image, Skeleton, message, Input, Grid } from "antd";
import { useForm } from "antd/es/form/Form";
import Pdfimg from '../../../assets/pdf.png';
import { FiDownload } from "react-icons/fi";
import Button from "../../elements/button/component";
import dayjs from "dayjs";
import { ENVIRONMENT, NEXPYN_BUCKET, NEXPYN_CONDITION_REPORT_API } from "../../../common/constants";
import ImagePolygonLabeler from "./image-segment";
import ImageCropper from "./crop-image";

export const ConditionReportModal = (props: any) => {
    const {
        id,
        open,
        setOpen,
        version,
        setConditionReportModalLoading,
        conditionReportModalLoading,
        title,
        fileName,
        date,
        userName,
        fileS3Path,
        // userEmail,
        userId,
        artistName,
        measurements,
    } = props;

    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.md;
    const isTablet = !screens.lg;

    const [cropModalOpen, setCropModalOpen] = useState<boolean>(false);
    const [pdfModalopen, setPdfModalOpen] = useState<boolean>(false);
    const [pdfOpen, setPdfOpen] = useState<boolean>(false);
    const [pdfModalLoading, /* setPdfModalLoading */] = useState<boolean>(false);
    const [isFrameShow, setIsFrameShow] = useState(false);
    const [isFrameShow2, setIsFrameShow2] = useState(false);
    const [pdfPath, setPdfpath] = useState('');
    const [conditionReportForm] = useForm();
    const [type, setType] = useState('painting-artwork');
    const [conditionReport, setConditionReport] = useState<any>([]);
    const [bodingBox, setBodingBox] = useState<any>(null);
    const [imageUrl, setImageUrl] = useState<string>('');

    const inputStyle = {
        minHeight: '37px',
        paddingLeft: '12px',
        paddingRight: '12px',
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: 400,
        background: '#F3F4F6FF',
        borderRadius: '6px',
        borderWidth: '0px',
        outline: 'none',
        alignItems: 'center'
    };

    const inputLabelStyle = {
        fontSize: '13px',
        lineHeight: '22px',
        fontWeight: 600,
    };

    const planarDistortions = [
        { label: 'All', value: 'All', disabled: true },
        { label: 'Wrinkles', value: 'wrinkles', disabled: true },
        { label: 'Folds', value: 'folds', disabled: true },
        { label: 'Cracks', value: 'crack', disabled: true },
        { label: 'Creases', value: 'creases', disabled: true },
        { label: 'Tears', value: 'tear', disabled: true },
        { label: 'Abrasion', value: 'abrasion', disabled: true },
    ];

    const accretions = [
        { label: 'All', value: 'All', disabled: true },
        { label: 'Losses', value: 'losses', disabled: true },
        { label: 'Holes', value: 'hole', disabled: true },
        { label: 'Fading', value: 'fading', disabled: true },
        { label: 'Thinning', value: 'thinning', disabled: true },
        { label: 'Darkening', value: 'darkening', disabled: true },
        { label: 'Yellowing', value: 'yellowing', disabled: true }
    ];

    const discoloration = [
        { label: 'All', value: 'All', disabled: true },
        { label: 'Stains', value: 'stains', disabled: true },
        { label: 'Soil', value: 'soil', disabled: true },
        { label: 'Grime', value: 'grime', disabled: true },
        { label: 'Mold', value: 'mold', disabled: true },
        { label: 'Insect damage', value: 'insect-damage', disabled: true },
        { label: 'Attachments (tape, patches, stamps)', value: 'attachments', disabled: true }
    ];

    const media = [
        { label: 'All', value: 'All', disabled: true },
        { label: 'Discoloration', value: "discoloration", disabled: true },
        { label: 'Stains', value: "stain", disabled: true },
        { label: 'Leaching', value: "leaching", disabled: true },
        { label: 'Fading', value: "fading", disabled: true },
        { label: 'Flaking paint (avoid manipulation)', value: "flaking-paint", disabled: true },
        { label: 'Friable/powdery', value: "friable/powdery", disabled: true },
        { label: 'Accretions', value: "accretions", disabled: true },
        { label: 'Smudging', value: "smudging", disabled: true },
        { label: 'Losses', value: 'losses', disabled: true },
        { label: 'Abrasion', value: 'abrasion', disabled: true },
    ];

    const mitersLoose = [
        { label: 'All', value: 'All', disabled: true },
        { label: 'Wires & Screws Attached', value: "wires-and-screws-attached", disabled: true },
        { label: 'Chipped', value: "chipped", disabled: true },
        { label: 'Cracked', value: "crack", disabled: true },
        { label: 'Loose Pieces', value: "loose-pieces", disabled: true },
        { label: 'Gesso or Finish Flaking', value: "gesso-or-finish-flaking", disabled: true },
        { label: 'Slipped Hinges', value: "slipped-hinges", disabled: true },
        { label: 'Losses', value: 'frame-losses', disabled: true },
        { label: 'Miters Loose', value: "miters-loose", disabled: true },
    ];

    const support = [
        { label: 'All', value: 'All' },
        { label: 'Slack', value: 'slack', disabled: true },
        { label: 'Buckling', value: 'buckling', disabled: true },
        { label: 'Puncture/Tear', value: 'puncture/tear', disabled: true },
        { label: 'Breaks', value: 'break', disabled: true},
        { label: 'Accretions', value: 'accretions' },
        { label: 'Warp', value: 'warp', disabled: true },
        { label: 'Draw', value: 'draw', disabled: true },
        { label: 'Bulges', value: 'bulges', disabled: true },
        { label: 'Worn', value: 'worn', disabled: true },
    ];

    const groundAndPaintLayer = [
        { label: 'All', value: 'All'},
        { label: 'Crackle', value: 'crack' },
        { label: 'Blister', value: 'blister', disabled: true },
        { label: 'Flaking', value: 'flaking'},
        { label: 'Dents', value: 'dents', disabled: true },
        { label: 'Raised Cracks', value: 'raised-cracks', disabled: true },
        { label: 'Cupping', value: 'cupping', disabled: true },
        { label: 'Paint Losses', value: 'paint-losses' },
        { label: 'Discoloration', value: 'discoloration' },
    ];

    const frameAndBacking = [
        { label: 'All', value: 'All', disabled: true },
        { label: 'Wires & Screws Attached', value: 'wires-and-screws-attached', disabled: true },
        { label: 'Degradation', value: 'degradation', disabled: true },
        { label: 'Chips', value: 'chips', disabled: true },
        { label: 'Cracks', value: 'cracks', disabled: true },
        { label: 'Holes', value: 'holes', disabled: true },
        { label: 'Loose Molding', value: 'loose-molding', disabled: true },
        { label: 'Losses', value: 'losses', disabled: true },
    ];

    const paperArtworkConditionReport = [
        {
            title: 'Support Pages',
            fields: [
                'Planar Distortions',
                'Accretions',
                'Discoloration'
            ]
        },
        {
            title: 'Media',
            fields: ['Media']
        },
        {
            title: "",
            fields: ['Is the artpiece enclosed in a frame ?']
        },
        (isFrameShow ? { title: 'Frame or Housing', fields: ['Frame or Housing'] } : {}),
        // ({ title: 'Frame or Housing', fields: ['Frame or Housing'] }),
        {
            title: "Notes",
            fields: ['Notes']
        }
    ];

    const paintingArtworkConditionReport = [
        {
            title: 'Support',
            fields: [
                'Support'
            ]
        },
        {
            title: 'Ground and Paint Layer',
            fields: ['Ground and Paint Layer']
        },
        {
            title: "",
            fields: ['Is the artpiece enclosed in a frame ?']
        },
        (isFrameShow2 ? { title: 'Frame and Backing', fields: ['Frame and Backing'] } : {}),
        // ({ title: 'Frame and Backing', fields: ['Frame and Backing'] }),
        {
            title: "Notes",
            fields: ['Notes']
        }
    ];

    const generatePdf = (fieldValue: any, field: string, title: string) => {
        const value = typeof (fieldValue) === 'string' ? [] : fieldValue;
        const optionList = options(field, title);
        const filteredValues = optionList?.filter((val: any) => val.value !== 'All')?.map((values) => values.value);
        if (value?.includes('All') && !filteredValues?.some(item => value?.includes(item))) {
            conditionReportForm.setFieldValue(field, ['All']);
        } else if (value[value?.length - 1] === 'All') {
            conditionReportForm.setFieldValue(field, ['All']);
        } else if (value[value?.length - 1] !== 'All') {
            const filteredValue = value?.filter((val: any) => val !== 'All');
            conditionReportForm.setFieldValue(field, filteredValue);
        }
        if (title === '') {
            if (type === 'paper-artwork') {
                setIsFrameShow(fieldValue?.includes('Yes') ? true : false);
                conditionReportForm.setFieldValue(['Frame or Housing'], ['All']);
            } else if (type === 'painting-artwork') {
                setIsFrameShow2(fieldValue?.includes('Yes') ? true : false);
                // conditionReportForm.setFieldValue(['Frame and Backing'], ['All']);
            }
        }
    };

    const options = (field?: any, title?: string, value?: any) => {
        switch (field) {
            case "Planar Distortions": {
                if (value && value?.includes('All')) {
                    return planarDistortions?.filter(option => option.value !== "All" && option.disabled !== true);
                } else {
                    return planarDistortions;
                }
            }
            case "Accretions": {
                if (value && value?.includes('All')) {
                    return accretions?.filter(option => option.value !== "All" && option.disabled !== true);
                } else {
                    return accretions;
                }
            }
            case "Discoloration": {
                if (value && value?.includes('All')) {
                    return discoloration?.filter(option => option.value !== "All" && option.disabled !== true);
                }
                return discoloration;
            }
            case "Is the artpiece enclosed in a frame ?": {
                return [
                    { label: 'Yes', value: 'Yes' },
                    { label: 'No', value: 'No' },
                ];
            }
            case 'Media': {
                if (value && value?.includes('All')) {
                    return media?.filter(option => option.value !== "All" && option.disabled !== true);
                }
                return media;
            }
            case 'Frame or Housing': {
                if (value && value?.includes('All')) {
                    return mitersLoose?.filter(option => option.value !== "All" && option.disabled !== true);
                }
                return mitersLoose;
            }
            case 'Support': {
                if (value && value?.includes('All')) {
                    return support?.filter(option => option.value !== "All" && option.disabled !== true);
                }
                return support;
            }
            case 'Ground and Paint Layer': {
                if (value && value?.includes('All')) {
                    return groundAndPaintLayer?.filter(option => option.value !== "All" && option.disabled !== true);
                }
                return groundAndPaintLayer;
            }
            case 'Frame and Backing': {
                if (value && value?.includes('All')) {
                    return frameAndBacking?.filter(option => option.value !== "All" && option.disabled !== true);
                }
                return frameAndBacking;
            }
            default:
                return [];
        }
    };

    const selectField = (field: string, title?: any) => {
        const optionList = options(field, title);
        // const allOption: any = [{ label: 'All', value: 'All' }];
        const sortedList = title === "" ? optionList : optionList?.sort((a, b) => {
            if (a?.label === 'All') { return -1; }
            if (b?.label === 'All') { return 1; }
            return a?.label?.localeCompare(b?.label);
        });

        return (
            <Select
                options={optionList ? sortedList : []}
                mode={title === '' ? undefined : "multiple"}
                style={inputStyle}
                defaultValue={title === '' ? ['Yes'] : null}
                onChange={(e) => generatePdf(e, field, title)}
                disabled={conditionReportModalLoading}
                getPopupContainer={(triggerNode) => triggerNode?.parentElement ?? document?.body}
            />
        );
    };

    const SubmitForm = async () => {
        const condition: any = {};

        try {
            setConditionReportModalLoading(true);

            const submitedValue = conditionReportForm.getFieldsValue();
            console.log('submitedValue', submitedValue);

            // Remove unused fields
            delete submitedValue?.['Notes'];
            delete submitedValue?.['artpieceFrame'];
            delete submitedValue?.['artpieceFrame2'];

            // Utility to replace "All" with actual values
            const normalizeValue = (key: string, value: any) => {
                if (Array.isArray(value) && value.includes('All')) {
                    return options(key, '', 'All')?.map((item: any) => item.value);
                }
                return value;
            };

            // Process condition fields
            const keys = ['Planar Distortions', 'Accretions', 'Discoloration'];
            for (const key of keys) {
                let value = submitedValue?.[key];
                value = normalizeValue(key, value);

                if (Array.isArray(value) && value.length > 0) {
                    condition['support-page'] = [
                        ...(condition['support-page'] ?? []),
                        ...value
                    ];
                }
            }

            // Media
            const media = normalizeValue('Media', submitedValue?.['Media']);
            if (Array.isArray(media) && media.length > 0) {
                condition['media'] = media;
            }

            // Frame or Housing and Frame and Backing
            if (type === 'paper-artwork') {
                const frame = normalizeValue('Frame or Housing', submitedValue?.['Frame or Housing']);
                if (Array.isArray(frame) && frame.length > 0) {
                    condition['frame-or-housing'] = frame;
                }
            } else if (type === 'painting-artwork') {
                const frameAndBacking = normalizeValue('Frame and Backing', submitedValue?.['Frame and Backing']);
                if (Array.isArray(frameAndBacking) && frameAndBacking.length > 0) {
                    condition['frame-and-backing'] = frameAndBacking;
                }
            }

            // Support
            const support = normalizeValue('Support', submitedValue?.['Support']);
            if (Array.isArray(support) && support.length > 0) {
                condition['support'] = support;
            }

            // Ground and Paint Layer
            const groundAndPaintLayer = normalizeValue('Ground and Paint Layer', submitedValue?.['Ground and Paint Layer']);
            if (Array.isArray(groundAndPaintLayer) && groundAndPaintLayer.length > 0) {
                condition['paint-layer'] = groundAndPaintLayer;
            }

            const frameCondition = () => {
                if (type === 'paper-artwork') {
                    return isFrameShow ? 'yes' : 'no';
                } else if (type === 'painting-artwork') {
                    return isFrameShow2 ? 'yes' : 'no';
                }
                return 'no';
            };

            // Final request payload
            const requestBody: any = {
                s3_key: `${id}/${version}/${fileName}`,
                output_s3_path: `${id}/${version}`,
                bucket_name: NEXPYN_BUCKET,
                artpieceEnclosedInFrame: frameCondition(),
                parameters: {
                    type,
                    condition
                },
                art_details: {
                    user_id: userId,
                    user_name: userName,
                    inventory_no: measurements?.inventoryNo,
                    artwork_title: title,
                    artist_name: artistName,
                    examiner: measurements?.examiner || userName,
                    date_of_artwork: dayjs(date)?.format('DD-MMMM-YYYY'),
                    date_of_report: dayjs(new Date())?.format('DD-MMMM-YYYY'),
                    height: measurements?.height,
                    width: measurements?.width,
                    depth: measurements?.depth,
                    notes: conditionReportForm?.getFieldValue('Notes'),
                },
                boding_box: {}
            };

            if (!imageAnnotationToolDisabled()) {
                if (!bodingBox) {
                    message.warning('No annotations to save. Please add polygons before generating the report.');
                    return;
                }
                if (
                    (!bodingBox.frame || bodingBox.frame.length === 0) &&
                    (!bodingBox.support || bodingBox.support.length === 0)
                ) {
                    message.warning('No annotations to save. Please add polygons before generating the report.');
                    requestBody.boding_box = {};
                    return;
                } else {
                    requestBody.boding_box.frame = bodingBox.frame?.length ? bodingBox.frame : [];
                    requestBody.boding_box.support = bodingBox.support?.length ? bodingBox.support : [];
                }

            } else {
                if (bodingBox?.crop && bodingBox?.crop?.length) {
                    requestBody.boding_box.crop = bodingBox.crop?.length ? bodingBox.crop : [];
                }
            }

            console.log('requestBody', requestBody);
            // return;
            const response = await fetch(NEXPYN_CONDITION_REPORT_API, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data?.message || 'Error from backend');
            }

            message.success('Report generated successfully');
            console.log("Report URL:", data.report_url);
            await downloadPdf(data.presigned_url);
            // setPdfpath(data.report_url);
            // setPdfOpen(true);

        } catch (error) {
            console.error('Error while generating report', error);
            message.error('Error while generating report, please try again.');
        } finally {
            setConditionReportModalLoading(false);
        }
    };

    useEffect(() => {
        if (fileS3Path) {
            setImageUrl(`https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/${fileS3Path}`);
        }
    }, [fileS3Path]);

    // const sendWebSocketMessage = (payload: any): Promise<any> => {
    //     return new Promise((resolve, reject) => {
    //         const socket = new WebSocket(`wss://w6abhaoqo2.execute-api.us-east-1.amazonaws.com/dev/`);

    //         socket.onopen = () => {
    //             console.log("WebSocket connected, sending message...");
    //             socket.send(JSON.stringify(payload));
    //         };

    //         socket.onmessage = (event: any) => {
    //             const data = JSON.parse(event.data);
    //             console.log("Received:", data);

    //             if (data.status === 'Success') {
    //                 message.success('Report generated successfully');
    //                 setPdfpath(data.report_url);
    //                 setPdfOpen(true);
    //             } else {
    //                 message.error('Error while generating report please try again');
    //             }

    //             setConditionReportModalLoading(false);
    //             socket.close();
    //             resolve(data);
    //         };

    //         socket.onerror = (error: any) => {
    //             console.error("WebSocket error:", error);
    //             message.error('WebSocket connection failed');
    //             setConditionReportModalLoading(false);
    //             socket.close();
    //             reject(error);
    //         };

    //         socket.onclose = (event) => {
    //             console.log("WebSocket closed:", event.reason);
    //         };
    //     });
    // };

    useEffect(() => {
        conditionReportForm.setFieldsValue({
            'Planar Distortions': ['All'],
            'Accretions': ['All'],
            'Discoloration': ['All'],
            'Media': ['All'],
            'artpieceFrame1': ['No'],
            'artpieceFrame2': ['No'],
            // 'Frame or Housing': ['All'],
            'Support': ['All'],
            'Ground and Paint Layer': ['All'],
            // 'Frame and Backing': ['All'],
            'Notes': '',
        });
        if (type === 'paper-artwork') {
            setIsFrameShow(false);
            setConditionReport(paperArtworkConditionReport);
        } else if (type === 'painting-artwork') {
            setIsFrameShow2(false);
            setConditionReport(paintingArtworkConditionReport);
        }
    }, []);

    useEffect(() => {
        onChange(type);
    }, [isFrameShow, isFrameShow2]);

    const onChange = (value: string) => {
        setType(value);
        console.log('value', value);
        if (value === 'paper-artwork') {
            setConditionReport(paperArtworkConditionReport);
        } else if (value === 'painting-artwork') {
            setConditionReport(paintingArtworkConditionReport);
        } else if (value === '3d-artwork') {
            setConditionReport([]);
        }
    };

    const frame = () => {
        if (type === 'paper-artwork') {
            return 'artpieceFrame';
        } else if (type === 'painting-artwork') {
            return 'artpieceFrame2';
        }
    };

    const [visible, setVisible] = useState(false);

    const handleSubmit = (polygons: any) => {
        setBodingBox(polygons);
        console.log("Bounding Box:", polygons);
        console.log("Frame Polygons:", polygons.frame);
        console.log("Support Polygons:", polygons.support);
    };

    const imageAnnotationToolDisabled = () => {
        if (type == 'paper-artwork' && !isFrameShow) {
            return true;
        } else if (type == 'painting-artwork' && !isFrameShow2) {
            return true;
        } else {
            return false;
        }
    };

    const downloadPdf = async (presignedUrl: string) => {
        const key = "download_pdf";

        message.loading({ content: "Downloading PDF...", key, duration: 0 });

        try {
            const link = document.createElement("a");
            link.href = presignedUrl;
            link.download = "condition_report.pdf";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setTimeout(() => {
                message.success({
                    content: "File downloaded. Please check your Downloads folder.",
                    key,
                    duration: 7,
                });
            }, 2500);
        } catch (err) {
            message.error({
                content: "Download failed. Try again.",
                key,
                duration: 4,
            });
            console.error(err);
        }
    };

    const handleCropDone = (blob: any, bondingBox: any) => {
        // const url = URL.createObjectURL(blob);
        console.log('blob', blob);
        console.log('bondingBox', bondingBox);
        setBodingBox(bondingBox);
    };

    return (
        <>
            <Modal
                title={
                    <div className="condition-report-modal-header" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        flexDirection: isMobile ? 'column' : 'row',
                        width: '100%',
                        paddingRight: isMobile ? '40px' : '40px',
                        paddingTop: isMobile ? '8px' : '0'
                    }}>
                        <span
                            style={{
                                fontSize: isMobile ? '16px' : '20px',
                                fontWeight: 700,
                                color: '#171A1FFF',
                                textAlign: isMobile ? 'center' : 'left',
                                width: isMobile ? '100%' : 'auto',
                                lineHeight: '1.4',
                                paddingRight: isMobile ? '0' : '0'
                            }}
                        >
                            {`Generat${conditionReportModalLoading ? 'ing' : 'e'} Condition Report for - ${title} (${version})`}
                        </span>
                        <div className="condition-report-controls" style={{
                            display: 'flex',
                            gap: '12px',
                            flexDirection: isMobile ? 'column' : 'row',
                            width: isMobile ? '100%' : 'auto',
                            alignItems: isMobile ? 'stretch' : 'center',
                            marginTop: isMobile ? '12px' : '0'
                        }}>
                            <Select
                                size="middle"
                                defaultValue="painting-artwork"
                                onChange={(value) => onChange(value)}
                                style={{
                                    width: isMobile ? '100%' : 200,
                                    display: 'block',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    borderRadius: 8,
                                    padding: '4px 12px',
                                    backgroundColor: '#f9f9f9',
                                }}
                                dropdownStyle={{
                                    borderRadius: 10,
                                    fontSize: '14px',
                                    padding: '4px 0',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                }}
                                disabled={conditionReportModalLoading}
                            >
                                <Select.Option value="paper-artwork">Paper Artwork</Select.Option>
                                <Select.Option value="painting-artwork">Painting Artwork</Select.Option>
                                {/* <Select.Option value="3d-artwork">3D Artwork</Select.Option> */}
                            </Select>
                            {
                                (isFrameShow || isFrameShow2) ?
                                    <Button
                                        type="primary"
                                        style={{
                                            ...(imageAnnotationToolDisabled() || conditionReportModalLoading ? {} : { background: 'rgb(99, 106, 232)', color: "#fff" }),
                                            width: isMobile ? '100%' : 'auto',
                                            display: 'block',
                                        }}
                                        onClick={() => setVisible(true)}
                                        disabled={imageAnnotationToolDisabled() || conditionReportModalLoading}
                                    >
                                        {isMobile ? 'Image Annotation Tool' : 'Image Annotation Tool'}
                                    </Button>
                                    :
                                    <Button
                                        type="primary"
                                        style={{
                                            ...(conditionReportModalLoading ? {} : { background: 'rgb(99, 106, 232)', color: "#fff" }),
                                            width: isMobile ? '100%' : 'auto',
                                            display: 'block',
                                        }}
                                        onClick={() => setCropModalOpen(true)}
                                        disabled={conditionReportModalLoading}
                                    >
                                        Crop Image
                                    </Button>
                            }
                        </div>
                    </div>
                }
                open={open}
                width={isMobile ? '95%' : isTablet ? '90%' : '80%'}
                className="condition-report-modal"
                onCancel={() => {
                    if (conditionReportModalLoading) {
                        message.info('Please wait for the report to be generated');
                    } else {
                        setOpen(false);
                        conditionReportForm?.resetFields();
                        if (type === 'paper-artwork') {
                            setIsFrameShow(true);
                        } else if (type === 'painting-artwork') {
                            setIsFrameShow2(true);
                        }
                    }
                }}
                maskClosable={false}
                footer={[
                    <div key={id} className="condition-report-footer" style={{
                        marginTop: 20,
                        display: 'flex',
                        gap: '12px',
                        flexDirection: isMobile ? 'column' : 'row',
                        justifyContent: isMobile ? 'stretch' : 'flex-end'
                    }}>
                        <Button
                            disabled={conditionReportModalLoading}
                            key="back"
                            danger
                            onClick={() => {
                                setOpen(false);
                                conditionReportForm?.resetFields();
                                if (type === 'paper-artwork') {
                                    setIsFrameShow(true);
                                } else if (type === 'painting-artwork') {
                                    setIsFrameShow2(true);
                                }
                            }}
                            style={{
                                fontSize: '14px',
                                fontWeight: 400,
                                borderRadius: '6px',
                                marginRight: isMobile ? 0 : 12,
                                width: isMobile ? '100%' : 'auto'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            disabled={conditionReportModalLoading || (type === 'paper-artwork')}
                            key="submit"
                            type='primary'
                            onClick={() => { SubmitForm(); }}
                            loading={conditionReportModalLoading}
                            style={{
                                background: 'rgb(99, 106, 232)',
                                color: "#fff",
                                width: isMobile ? '100%' : 'auto'
                            }}
                        >
                            {conditionReportModalLoading ? 'Generating Report...' : 'Generate Report'}
                        </Button>
                    </div>
                ]}
            >
                <Card className="condition-report-card">
                    <Form
                        layout="vertical"
                        form={conditionReportForm}
                        onFinish={SubmitForm}
                        requiredMark={false}
                    >{conditionReport?.map((fields: any, i: any) => <Fragment key={i}>
                        <h3 style={{
                            marginBottom: 10,
                            color: '#171A1FFF',
                            fontSize: isMobile ? '16px' : '18px'
                        }}
                        >{fields?.title == "" ? 'Is the artpiece enclosed in a frame ?' : fields?.title}</h3>
                        <Row gutter={[16, 16]} className="condition-report-form-row">
                            {fields?.fields?.map((field: any, index: React.Key) => {
                                const isLabelHidden = [
                                    'Media',
                                    'Frame or Housing',
                                    'Frame and Backing',
                                    'Notes',
                                    'Is the artpiece enclosed in a frame ?',
                                    'Support',
                                    'Ground and Paint Layer',
                                ].includes(field);

                                const isTextarea = field === 'Notes';

                                return (
                                    <Col
                                        key={index}
                                        xs={24}
                                        sm={12}
                                        md={8}
                                        lg={8}
                                        xl={8}
                                        className="condition-report-form-col"
                                    >
                                        <Form.Item
                                            label={
                                                !isLabelHidden ? <span style={inputLabelStyle}>{field}</span> : null
                                            }
                                            name={fields?.title === '' ? frame() : field}
                                        >
                                            {isTextarea ? (
                                                <Input.TextArea
                                                    disabled={conditionReportModalLoading}
                                                    rows={isMobile ? 3 : 4}
                                                    style={inputStyle}
                                                />
                                            ) : (
                                                selectField(field, fields?.title)
                                            )}
                                        </Form.Item>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Fragment>)}
                    </Form>
                </Card>
                <ImagePolygonLabeler
                    visible={visible}
                    onClose={() => setVisible(false)}
                    imageUrl={imageUrl}
                    // maxWidth={800}
                    // maxHeight={600}
                    onSubmit={handleSubmit}
                />

                <ImageCropper
                    imageSrc={imageUrl}
                    open={cropModalOpen}
                    onClose={() => setCropModalOpen(false)}
                    onCropDone={handleCropDone}
                    setBodingBox={setBodingBox}
                />
            </Modal>
            {/* pdf viewer */}
            <Modal
                maskClosable={false}
                open={pdfModalopen}
                onCancel={() => { setPdfModalOpen(false); }}
                onClose={() => { setPdfModalOpen(false); }}
                width={isMobile ? '95%' : '80%'}
                className="pdf-viewer-modal"
                title={<span
                    style={{
                        fontSize: isMobile ? '16px' : '20px',
                        fontWeight: 700,
                        color: '#171A1FFF'
                    }}>
                    {`Generat${pdfModalLoading ? 'ing' : 'ed'} Report for Artwork - ${version}`}
                </span >}
                footer={pdfModalLoading ? null :
                    <div key={id} className="pdf-viewer-footer" style={{
                        marginTop: 20,
                        display: 'flex',
                        gap: '12px',
                        flexDirection: isMobile ? 'column' : 'row',
                        justifyContent: isMobile ? 'stretch' : 'center'
                    }}>
                        <Button
                            key="back"
                            type="primary"
                            onClick={() => { setPdfOpen(true); }}
                            style={{
                                letterSpacing: "0.5px",
                                fontWeight: "bold",
                                background: 'rgb(99, 106, 232)',
                                marginRight: isMobile ? 0 : 20,
                                width: isMobile ? '100%' : 'auto'
                            }}
                        >
                            View Report
                        </Button>
                        <Button
                            type="primary"
                            icon={<FiDownload />}
                            // onClick={() => { handleDownload(); }}
                            // loading={downloadButtonLoading}
                            style={{
                                letterSpacing: "0.5px",
                                fontWeight: "bold",
                                background: 'rgb(99, 106, 232)',
                                width: isMobile ? '100%' : 'auto'
                            }}
                        >
                            Download Report
                        </Button>
                    </div>
                }
            >
                {pdfModalLoading ? <Skeleton.Button
                    style={{ height: "20vh", marginTop: "1.4%" }}
                    active={true}
                    size={'small'}
                    shape={"square"}
                    block={true}
                /> :
                    <Row justify={'center'} className="pdf-preview-row">
                        <Col xs={24} sm={16} md={12} lg={16} xl={16} className="pdf-preview-col">
                            <Image
                                style={{ cursor: 'pointer' }}
                                onClick={() => { setPdfOpen(true); }}
                                preview={false}
                                src={Pdfimg}
                            />
                        </Col>
                    </Row>}
            </Modal>

            <Modal
                className="pdf-modal"
                maskClosable={false}
                open={pdfOpen}
                onOk={() => setPdfOpen(false)}
                onCancel={() => { setPdfOpen(false); setPdfpath(''); }}
                footer={null}
                width="100vw"
                style={{
                    top: 0,
                }}
                styles={{
                    body: {
                        height: "90vh",
                        padding: 0,
                    },
                }}
            >
                <iframe
                    title="Image Detection"
                    key={Date.now()}
                    className="pdf"
                    src={`https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/${pdfPath}?t=${Date.now()}`}
                    style={{
                        width: "100%",
                        height: "90%",
                        border: "none",
                        marginTop: '40px'
                    }}
                />
            </Modal>
        </>
    );
};